// extracted by mini-css-extract-plugin
export default {"userDataWrapper":"styles_userDataWrapper__jfB4e","userData":"styles_userData__AP5FD","removeDataModal":"styles_removeDataModal__7H7Ta","noticeModal":"styles_noticeModal__x318N"};